// extracted by mini-css-extract-plugin
export default {"no-subscriptions-alert":"style_no-subscriptions-alert__kWlKE","no-subscriptions-alert-content":"style_no-subscriptions-alert-content__OmuG1"};